<template>
  <div>
    <el-dialog
      title="标题"
      :visible="isOpen"
      :show-close="true"
      :before-close="cancel"
      :append-to-body="true"
      custom-class="title-dialog"
      top="5vh"
    >
      <el-tabs v-model="title_active_name">
        <el-tab-pane label="选中标题" name="d_total">
          <!-- 标题筛选 -->
          查询：
          <el-input
            v-model="tablep.params.name"
            placeholder="请输入标题名称"
            size="mini"
            class="seach_input"
            clearable
            @input="seachTitle"
          />
          <div class="bacth_delete">
            <el-button v-if="checked_list.length" size="mini" @click="bacthDelete">批量删除</el-button>
          </div>
          <div>
            <!-- 标题表格 -->
            <div class="title-list">
              <app-table
                ref="my-table"
                detail="skip"
                max-height="535"
                :table-key="tableKey"
                :is-reserve-checked="true"
                :tablep="tablep.params"
                :check="true"
                :is-row-click="true"
                :is-radio="isRadio"
                :get-data="getTitleList"
                @select-tr="titleSelectTr"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批量上传" name="upload_title">
          <div class="upload-title">
            <div>
              插入动态词包：
              <el-link
                :underline="false"
                type="primary"
                @click="insertStr('{地点}')"
              >
                +地点
              </el-link>
              <el-link
                :underline="false"
                type="primary"
                @click="insertStr('{年龄}')"
              >
                +年龄
              </el-link>
              <el-link
                :underline="false"
                type="primary"
                @click="insertStr('{日期}')"
              >
                +日期
              </el-link>
              <el-link
                :underline="false"
                type="primary"
                @click="insertStr('{星期}')"
              >
                +星期
              </el-link>
            </div>
            <div class="title-list-box">
              <div class="f-left">
                <ul>
                  <li v-for="index of max_len" :key="index">
                    <span
                      :class="[
                        { 'title-index': true },
                        {
                          'title-wrong':
                            add_title_list.length < index
                              ? false
                              : add_title_list[index - 1].is_success
                                ? false
                                : true,
                        },
                      ]"
                    >
                      {{ index }}
                    </span>
                  </li>
                </ul>
              </div>

              <div class="f-right title-input-list">
                <ul>
                  <li v-for="(item, index) in add_title_list" :key="index">
                    <div
                      :class="[
                        { 'title-input': true },
                        { 'input-action': title_input_index === index },
                      ]"
                    >
                      <input
                        ref="inputRename"
                        v-model="item.name"
                        placeholder="请输入或粘贴创意标题，每行一标题，敲击回车换行"
                        @keydown="inputDown"
                        @keyup="inputUp"
                        @focus="setFocusIndex(index)"
                        @blur="blurEvent"
                        @input="inputEvent"
                      >
                      <i
                        v-if="title_input_index != index"
                        class="el-icon-close"
                        @click.stop="delectItemTitle(item)"
                      />
                      <span v-if="title_input_index === index">
                        {{ getStrLen(item.name) }}/{{ maxLength }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <p v-if="is_title_tips" style="color: #f45858">
              <span>以下标题字数不符合{{ minLength }}-{{ maxLength }}个字规范：</span>
              <span
                v-for="(item, index) in wrong_list"
                :key="index"
                style="color: #2f88ff"
              >
                第{{ item + 1 }}行
              </span>
            </p>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitTitle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TitleResource from '@/api/title';
const titleResource = new TitleResource();
export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    minLength: {
      type: Number,
      default: 0,
    },
    maxLength: {
      type: Number,
      default: 30,
    },
    advertiserType: {
      type: String,
      default: 'gdt',
    },
  },
  data() {
    return {
      title_active_name: 'd_total', // 素材标签页
      dir_source_type: 'ALL', // 目录类型
      title_list: [],
      key_code: null,
      checked_list: [], // 选中项的id 集合
      tableKey: [
        {
          name: '素材ID',
          value: 'id',
        },
        {
          name: '标题',
          value: 'name',
        },
        {
          name: '平台',
          value: 'advertiser',
          format: (row, column, cell_value) => {
            const type = {
              'jrtt': '今日头条',
              'gdt': '广点通',
            };
            return type[cell_value];
          },
        },
        {
          name: '操作',
          value: 'id',
          width: 100,
          align: 'center',
          fixed: 'right',
          format: (row, column, cell_value) => {
            const h = this.$createElement;
            const ele = h('div',
              null, [
                h('el-button',
                  {
                    props: {
                      'size': 'mini',
                      'type': 'danger',
                    },
                    on: {
                      click: () => {
                        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                        })
                          .then(() => {
                            const params = {
                              advertiser: 'gdt',
                              source_ids: [cell_value],
                            };
                            // 删除请求
                            this.deleTitle(params, (res) => {
                              this.$refs['my-table'].seekTable();
                            });
                          })
                          .catch(() => {
                            this.$message({
                              type: 'info',
                              message: '已取消删除',
                            });
                          });
                      },
                    },
                  }, '删除'),
              ]);
            return ele;
          },
        },
      ],
      tablep: {
        params: {
          advertiser: 'gdt',
          material_type: 'title',
          limit: 10,
          page: 1,
        },
      },
      max_len: this.isRadio ? 1 : 200,
      title_input_index: 0,
      is_title_tips: false,
      wrong_list: [],
      add_title_list: [
        {
          name: '',
          is_success: true,
        },
      ],
    };
  },
  created() {
    this.tablep.params['max_length'] = this.maxLength;
    this.tablep.params['min_length'] = this.minLength;
    this.tablep.params['advertiser'] = this.advertiserType;
  },
  methods: {
    // 插入动态
    insertStr(str) {
      const s = this;
      const index = s.title_input_index;
      s.add_title_list[index].name += str;
      this.verifyText(s.add_title_list[index].name);
    },
    // 输入框enter换行
    inputUp(event) {
      if (event.keyCode === 13 || (this.key_code === 17 && event.keyCode === 86)){
        const s = this;
        this.blurEvent();

        if (this.add_title_list.length < s.max_len) {
          this.title_input_index++;
          if (this.title_input_index === this.add_title_list.length) {
            this.add_title_list.push({
              name: '',
              is_success: true,
            });
          }
          this.$nextTick(() => {
            s.$refs.inputRename[this.title_input_index].focus();
          });
        }
      }
    },

    // 输入框摁下ctrl
    inputDown(event){
      if (event.keyCode !== 86){
        this.key_code = event.keyCode;
      }
    },
    // 焦点事件
    blurEvent() {
      const val = this.add_title_list[this.title_input_index].name;
      const temp_list = val.split(/\s+/);

      for (let i = 0; i < temp_list.length; i++) {
        const item = temp_list[i];
        if (i > 0) {
          this.add_title_list.push({
            name: item,
            is_success: false,
          });
          this.title_input_index = this.add_title_list.length - 1;
          this.verifyText(item);
        } else {
          this.add_title_list[this.title_input_index].name = item;
          this.verifyText(item);
        }
      }
    },
    // 输入框事件
    inputEvent(event) {
      this.verifyText(event.target.value);
    },
    // 验证文本
    verifyText(val) {
      let isLen = false;

      const item = this.add_title_list[this.title_input_index];

      if (this.getStrLen(val) >= this.minLength && this.getStrLen(val) <= this.maxLength) {
        isLen = true;
      }

      if (isLen || val.length === 0) {
        item.is_success = true;
        const wrong_index = this.wrong_list.indexOf(this.title_input_index);
        if (wrong_index !== -1) {
          this.wrong_list.splice(wrong_index, 1);
        }
      } else {
        item.is_success = false;
        if (this.wrong_list.indexOf(this.title_input_index) === -1) {
          this.wrong_list.push(this.title_input_index);
        }
      }
      if (this.wrong_list.length === 0) {
        this.is_title_tips = !item.is_success;
      } else {
        this.is_title_tips = true;
      }
    },
    // 获取字符长度
    getStrLen(str) {
      var realLength = 0,
        len = str.length,
        charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 1;
        } else {
          realLength += 2;
        }
      }
      return Math.ceil(realLength / 2);
    },
    // 删除新增标题
    delectItemTitle(item) {
      const index = this.add_title_list.indexOf(item);
      if (this.add_title_list.length > 1) {
        const wrong_index = this.wrong_list.indexOf(index);
        this.wrong_list.splice(wrong_index, 1);
        this.add_title_list.splice(index, 1);
        if (this.add_title_list.length === 1) {
          this.title_input_index = 0;
        }
        if (this.wrong_list.length === 0) {
          this.is_title_tips = false;
        } else {
          this.is_title_tips = true;
        }

        if (wrong_index < this.wrong_list.length) {
          this.wrong_list = [];
          for (let i = 0; i < this.add_title_list.length; i++) {
            const item = this.add_title_list[i];
            if (!item.is_success) {
              this.wrong_list.push(i);
            }
          }
        }
      }
    },
    // 设置焦点索引
    setFocusIndex(index) {
      this.title_input_index = index;
    },
    // 获取标题列表
    getTitleList(params) {
      return new Promise((resolve, reject) => {
        titleResource
          .getApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 添加标题
    async addBatchTitle(params, callBack, errCallBack) {
      await titleResource
        .batchCreatApi(params)
        .then((response) => {
          if (callBack) {
            callBack(response);
          }
        })
        .catch((error) => {
          if (errCallBack) {
            errCallBack(error);
          }
        });
    },
    // 点击批量删除
    bacthDelete(){
      const params = {
        advertiser: 'jrtt',
        source_ids: this.checked_list,
      };
      this.deleTitle(params, (res) => {
        this.$message.success(res.message);
        this.tablep.params.page = 1;
        this.$refs['my-table'].seekTable();
      });
    },
    // 删除标题
    async deleTitle(params, callBack, errCallBack) {
      await titleResource
        .deleteApi(params)
        .then((response) => {
          if (callBack) {
            callBack(response);
          }
        })
        .catch((error) => {
          if (errCallBack) {
            errCallBack(error);
          }
        });
    },
    // 勾选行回调
    titleSelectTr(row) {
      this.checked_list = [];
      this.title_list = row;
      row.forEach(item => {
        this.checked_list.push(item.id);
      });
    },

    // 查询标题
    seachTitle(){
      this.$refs['my-table'].refer();
    },

    // 提交标题
    submitTitle() {
      let data = this.title_list;
      if (this.title_active_name === 'upload_title') {
        data = this.add_title_list.filter((item) => {
          if (item.is_success && item.name) {
            return item.is_success;
          }
        });
        const title_data = data.map((item) => {
          return item.name;
        });
        if (title_data.length > 0) {
          this.addBatchTitle({
            advertiser: this.advertiserType,
            names: title_data,
          });
        }
      }
      this.$emit('confirm', data);
    },
    // 取消
    cancel() {
      this.$emit('cancel', false);
    },
  },
};
</script>

<style scoped rel="stylesheet/scss" lang="scss">
/deep/ .title-dialog {
  width: auto;
  min-width: 1065px;
  max-width: 1065px;
  .material-container {
    .material-cord {
      min-height: 286px;
      position: relative;
      .constituency {
        overflow-y: scroll;
        height: 400px;
        width: 100%;
        ul {
          margin: 0;
          padding: 0;
          li {
            position: relative;
            list-style: none;
            border: 0;
            width: 245px;
            margin-top: 16px;
            margin-right: 12px;
            display: inline-block;
            background-color: #ccc;
            .item .img-show img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          li:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .seach_input{
    width: 300px;
    margin-bottom: 20px;
  }
  .bacth_delete{
    float: right;
  }
  .title-list-box {
    height: 375px;
    overflow: auto;
    .title-input-list {
      width: 95%;
      width: calc(100% - 36px);
      width: -moz-calc(100% - 36px);
      width: -webkit-calc(100% - 36px);
    }
    ul {
      padding: 0;
      li {
        list-style-type: none;
        .title-index {
          display: block;
          float: left;
          width: 36px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background-color: #edf1f5;
        }
        .title-wrong {
          background-color: red;
          color: #edf1f5;
        }
        .title-input {
          input {
            width: 95%;
            height: 36px;
            border: none;
            background: transparent;
          }
        }
        .input-action {
          background-color: #edf1f5;
        }
      }
    }
  }
  .f-left {
    float: left;
  }
  .f-right {
    float: right;
  }
  .label-border {
    width: 140px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    text-align: center;
    border: 1px #dcdee2 solid;
  }
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
  }
  .el-dialog__footer {
    border-top: 1px #d9d9d9 solid;
    padding: 15px 20px;
  }
  .dialog-footer {
    height: 54px;
    line-height: 54px;
    .thumb-img {
      float: left;
      width: 690px;
      height: 63px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      margin-left: 50px;
      text-align: left;
      .item {
        width: 95px;
        height: 54px;
        display: inline-block;
        text-align: center;
        border: 1px #aaa solid;
        margin: 0 10px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>
